var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', [_c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "dark-logo",
    attrs: {
      "src": "static/img/logo.png",
      "alt": "homepage"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center text-font"
  }, [_c('p', [_vm._v("Sever maintenance activity in progress.")]), _vm._v(" "), _c('p', [_vm._v("System will be available soon.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('img', {
    staticClass: "dark-logo",
    attrs: {
      "src": "static/img/under_maintainanace.png",
      "alt": "maintainanace"
    }
  })])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9227a9a4","hasScoped":true}!./src/views/components/maintenance/maintenance.component.html
// module id = 755
// module chunks = 1